import axios from "axios";

// Empty baseURL in local dev → requests go through the Vite proxy (/api →
// localhost:4000). In preview/prod VITE_API_URL points at the ezx-server ALB.
const baseURL = import.meta.env.VITE_API_URL || "";

export const api = axios.create({ baseURL });

// The Auth0 access token is injected by the SessionProvider via setAuthToken;
// the interceptor attaches it to every request. Keeping the token in a module
// scope (not per-call) means screen code never threads the token around.
let authToken: string | null = null;

export function setAuthToken(token: string | null) {
  authToken = token;
}

api.interceptors.request.use((config) => {
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});
